import React, { useState, useEffect, useRef} from 'react';
import { WorkyTime } from './CommonInterfaces';
import "./timepicker.css"
import { useIsMobile } from '../custom-hooks/useIsMobile';
import {
  WORKY_TIME_PICKER_V3_COMPACT_CLASS_NAME,
  WORKY_TIME_PICKER_V3_DISPLAY_SIZE,
  WorkyTimePickerV3DisplaySize,
} from './WorkyTimePickerV3Config';


const WorkyTimePicker = ({ onFinalTimeChangeHour, onFinalTimeChangeMinute }) => {
  // const initialAMPMState = new Date().getHours() <= 12 ? true : false;
  const [amActive, setamActive] = useState(true);
  const [pmActive, setpmActive] = useState(false);

  // hours
  const [hourInputValue, setHourInputValue] = useState(9);
  const hourNow = new Date().getHours();
  const hour12 = ((hourNow % 12) || 12).toString();

  const handleHourChange = (e) => {
    const value = e.target.value;
    const numericValue = value.replace(/\D/g, '');
    const clampedValue = Math.min(12, Math.max(0, parseInt(numericValue, 10)));
    setHourInputValue(clampedValue);
  };

  // mins
  const [minsInputValue, setMinsInputValue] = useState(0);
  const minsNow = new Date().getMinutes().toString().padStart(2, '0');

  const handleMinsChange = (e) => {
    const value = e.target.value;
    const numericValue = value.replace(/\D/g, '');
    const clampedValue = Math.min(59, Math.max(0, parseInt(numericValue, 10)));
    setMinsInputValue(clampedValue);
  };

    useEffect(() => {
        if (pmActive || amActive) {
            onFinalTimeChangeHour(hourInputValue + (pmActive ? 12 : 0));
            onFinalTimeChangeMinute(minsInputValue);
        }
    }, [amActive, pmActive, hourInputValue, minsInputValue, onFinalTimeChangeHour, onFinalTimeChangeMinute]);


  const handleAMClick = () => {
    setamActive(true);
    setpmActive(false);
  };

  const handlePMClick = () => {
    setamActive(false);
    setpmActive(true);
  };


  return (
      <div className='timepicker2'>
        <input
          className='tt2-hour'
          type="number"
          value={hourInputValue}
          onChange={handleHourChange}
          placeholder={"9"}
        />
        <div className='tt2-col'>:</div>
        <input
          className='tt2-mins'
          type="number"
          value={minsInputValue.toString().padStart(2, '0')}
          onChange={handleMinsChange}
          placeholder={"00"}          
        />
        <div className='tt2-ampm'>
          {amActive ? <button onClick={handleAMClick} id='ampm-active' className='tt2-am'>AM</button> : <button onClick={handleAMClick} className='tt2-am'>AM</button>}
          {pmActive ? <button onClick={handlePMClick} id='ampm-active' className='tt2-am'>PM</button> : <button onClick={handlePMClick} className='tt2-am'>PM</button>}
        </div>
      </div>
  );
};


const WorkyTimePickerFuture = ({ onFinalTimeChangeHour, onFinalTimeChangeMinute }) => {
  // const initialAMPMState = new Date().getHours()+8 <= 12 ? true : false;
  const [amActive, setamActive] = useState(false);
  const [pmActive, setpmActive] = useState(true);

  // hours
  const [hourInputValue, setHourInputValue] = useState(5);
  const hourNow = new Date().getHours()+8;
  const hour12 = ((hourNow % 12) || 12).toString();

  const handleHourChange = (e) => {
    const value = e.target.value;
    const numericValue = value.replace(/\D/g, '');
    const clampedValue = Math.min(12, Math.max(0, parseInt(numericValue, 10)));
    setHourInputValue(clampedValue);
  };

  // mins
  const [minsInputValue, setMinsInputValue] = useState(0);
  const minsNow = new Date().getMinutes().toString().padStart(2, '0');

  const handleMinsChange = (e) => {
    const value = e.target.value;
    const numericValue = value.replace(/\D/g, '');
    const clampedValue = Math.min(59, Math.max(0, parseInt(numericValue, 10)));
    setMinsInputValue(clampedValue);
  };

    useEffect(() => {
        if (pmActive || amActive) {
            onFinalTimeChangeHour(hourInputValue + (pmActive ? 12 : 0));
            onFinalTimeChangeMinute(minsInputValue);
        }
    }, [amActive, pmActive, hourInputValue, minsInputValue, onFinalTimeChangeHour, onFinalTimeChangeMinute]);


  const handleAMClick = () => {
    setamActive(true);
    setpmActive(false);
  };

  const handlePMClick = () => {
    setamActive(false);
    setpmActive(true);
  };



  return (
      <div className='timepicker2'>
        <input
          className='tt2-hour'
          type="number"
          value={hourInputValue}
          onChange={handleHourChange}
          placeholder={"5"}
        />
        <div className='tt2-col'>:</div>
        <input
          className='tt2-mins'
          type="number"
          value={minsInputValue.toString().padStart(2, '0')}
          onChange={handleMinsChange}
          placeholder={"00"}
        />
        <div className='tt2-ampm'>
          {amActive ? <button onClick={handleAMClick} id='ampm-active' className='tt2-am'>AM</button> : <button onClick={handleAMClick} className='tt2-am'>AM</button>}
          {pmActive ? <button onClick={handlePMClick} id='ampm-active' className='tt2-am'>PM</button> : <button onClick={handlePMClick} className='tt2-am'>PM</button>}
        </div>
      </div>
  );
}
 


const WorkyTimePickerV2 = ({prevHour, prevMin, onFinalTimeChangeHour, onFinalTimeChangeMinute }) => {
  const initialAMPMState = prevHour <= 12 ? true : false;
  const [amActive, setamActive] = useState(initialAMPMState);
  const [pmActive, setpmActive] = useState(!initialAMPMState);

  // hours
  const [hourInputValue, setHourInputValue] = useState<number>();
  const hourNow = new Date().getHours();
  const hour12 = (prevHour % 12).toString();
  console.log("hour12---->"+hour12)

  const handleHourChange = (e) => {
    const value = e.target.value;
    const numericValue = value.replace(/\D/g, '');
    const clampedValue = Math.min(12, Math.max(0, parseInt(numericValue, 10)));
    setHourInputValue(clampedValue);
  };

  // mins
  const [minsInputValue, setMinsInputValue] = useState<number>();
  const minsNow = prevMin.toString().padStart(2, '0');

  const handleMinsChange = (e) => {
    const value = e.target.value;
    const numericValue = value.replace(/\D/g, '');
    const clampedValue = Math.min(59, Math.max(0, parseInt(numericValue, 10)));
    setMinsInputValue(clampedValue);
  };

    useEffect(() => {
        if (pmActive || amActive) {
            onFinalTimeChangeHour(hourInputValue + (pmActive ? 12 : 0));
            onFinalTimeChangeMinute(minsInputValue);
        }
    }, [amActive, pmActive, hourInputValue, minsInputValue, onFinalTimeChangeHour, onFinalTimeChangeMinute]);


  const handleAMClick = () => {
    setamActive(true);
    setpmActive(false);
  };

  const handlePMClick = () => {
    setamActive(false);
    setpmActive(true);
  };


  return (
      <div className='timepicker2'>
        <input
          className='tt2-hour'
          type="number"
          value={hourInputValue}
          onChange={handleHourChange}
          placeholder={hour12}
        />
        <div className='tt2-col'>:</div>
        <input
          className='tt2-mins'
          type="number"
          value={minsInputValue}
          onChange={handleMinsChange}
          placeholder={minsNow}
        />
        <div className='tt2-ampm'>
          {amActive ? <button onClick={handleAMClick} id='ampm-active' className='tt2-am'>AM</button> : <button onClick={handleAMClick} className='tt2-am'>AM</button>}
          {pmActive ? <button onClick={handlePMClick} id='ampm-active' className='tt2-am'>PM</button> : <button onClick={handlePMClick} className='tt2-am'>PM</button>}
        </div>
      </div>
  );
};
/** 1–12 clock face + AM/PM → 0–23 (local convention: 12 AM → 0, 12 PM → 12). */
const convertTwelveHourClockTo24 = (hour12Clock: number, isPm: boolean): number => {
  if (hour12Clock === 12) {
    return isPm ? 12 : 0;
  }
  if (hour12Clock === 0) {
    return isPm ? 12 : 0;
  }
  return isPm ? hour12Clock + 12 : hour12Clock;
};

interface WorkyTimePickerV3DisplayConfig {
  /** Visual density. Defaults to default for existing callers. */
  readonly size?: WorkyTimePickerV3DisplaySize;
}

interface WorkyTimePickerV3Props {
  readonly prevHour: number | null;
  readonly prevMin: number | null;
  readonly onFinalTimeChangeHour: (hour: number) => void;
  readonly onFinalTimeChangeMinute: (minute: number) => void;
  /** Optional layout/size overrides. Omitted keeps the original default appearance. */
  readonly displayConfig?: WorkyTimePickerV3DisplayConfig;
}

const toTwelveHourClockFace = (hour24: number): number => {
  return (hour24 % 12) || 12;
};

const WorkyTimePickerV3 = ({
  prevHour,
  prevMin,
  onFinalTimeChangeHour,
  onFinalTimeChangeMinute,
  displayConfig,
}: WorkyTimePickerV3Props): React.ReactElement => {
  const isCompactDisplay: boolean =
    displayConfig?.size === WORKY_TIME_PICKER_V3_DISPLAY_SIZE.COMPACT;
  const resolvedPrevHour: number = prevHour == null || Number.isNaN(Number(prevHour)) ? 0 : Number(prevHour);
  const resolvedPrevMin: number = prevMin == null || Number.isNaN(Number(prevMin)) ? 0 : Number(prevMin);
  const initialHour12: number = toTwelveHourClockFace(resolvedPrevHour);
  const initialIsAm: boolean = resolvedPrevHour < 12;

  const [amActive, setamActive] = useState<boolean>(initialIsAm);
  const [pmActive, setpmActive] = useState<boolean>(!initialIsAm);
  const isMobile: boolean = useIsMobile();

  const [hourInputText, setHourInputText] = useState<string>(initialHour12.toString());
  const [minsInputText, setMinsInputText] = useState<string>(resolvedPrevMin.toString().padStart(2, '0'));
  const [hourInputValue, setHourInputValue] = useState<number>(initialHour12);
  const [minsInputValue, setMinsInputValue] = useState<number>(resolvedPrevMin);
  const hourInputTextRef = useRef<string>(hourInputText);
  const minsInputTextRef = useRef<string>(minsInputText);
  const lastSyncedPrevHourRef = useRef<number>(resolvedPrevHour);
  const lastSyncedPrevMinRef = useRef<number>(resolvedPrevMin);
  const onFinalTimeChangeHourRef = useRef(onFinalTimeChangeHour);
  const onFinalTimeChangeMinuteRef = useRef(onFinalTimeChangeMinute);
  const lastEmittedHour24Ref = useRef<number | null>(null);
  const lastEmittedMinuteRef = useRef<number | null>(null);

  hourInputTextRef.current = hourInputText;
  minsInputTextRef.current = minsInputText;
  onFinalTimeChangeHourRef.current = onFinalTimeChangeHour;
  onFinalTimeChangeMinuteRef.current = onFinalTimeChangeMinute;

  useEffect(() => {
    if (
      resolvedPrevHour === lastSyncedPrevHourRef.current &&
      resolvedPrevMin === lastSyncedPrevMinRef.current
    ) {
      return;
    }

    lastSyncedPrevHourRef.current = resolvedPrevHour;
    lastSyncedPrevMinRef.current = resolvedPrevMin;

    const nextHour12: number = toTwelveHourClockFace(resolvedPrevHour);
    setHourInputValue(nextHour12);
    setHourInputText(nextHour12.toString());
    setMinsInputValue(resolvedPrevMin);
    setMinsInputText(resolvedPrevMin.toString().padStart(2, '0'));

    const nextIsAm: boolean = resolvedPrevHour < 12;
    setamActive(nextIsAm);
    setpmActive(!nextIsAm);
  }, [resolvedPrevHour, resolvedPrevMin]);

  const commitHourInput = (rawHourText: string): number => {
    const trimmedHourText: string = rawHourText.trim();
    if (trimmedHourText === '') {
      setHourInputText(hourInputValue.toString());
      return hourInputValue;
    }

    const parsedHour: number = parseInt(trimmedHourText, 10);
    if (Number.isNaN(parsedHour)) {
      setHourInputText(hourInputValue.toString());
      return hourInputValue;
    }

    const normalizedHour12: number = Math.min(12, Math.max(1, parsedHour));
    setHourInputText(normalizedHour12.toString());
    setHourInputValue(normalizedHour12);
    return normalizedHour12;
  };

  const commitMinuteInput = (rawMinuteText: string): number => {
    const trimmedMinuteText: string = rawMinuteText.trim();
    if (trimmedMinuteText === '') {
      const paddedMinuteText: string = minsInputValue.toString().padStart(2, '0');
      setMinsInputText(paddedMinuteText);
      return minsInputValue;
    }

    const parsedMinute: number = parseInt(trimmedMinuteText, 10);
    if (Number.isNaN(parsedMinute)) {
      const paddedMinuteText: string = minsInputValue.toString().padStart(2, '0');
      setMinsInputText(paddedMinuteText);
      return minsInputValue;
    }

    const normalizedMinute: number = Math.min(59, Math.max(0, parsedMinute));
    const paddedMinuteText: string = normalizedMinute.toString().padStart(2, '0');
    setMinsInputText(paddedMinuteText);
    setMinsInputValue(normalizedMinute);
    return normalizedMinute;
  };

  const handleHourChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
    const numericValue: string = event.target.value.replace(/\D/g, '').slice(0, 2);
    setHourInputText(numericValue);

    if (numericValue === '') {
      return;
    }

    const parsedHour: number = parseInt(numericValue, 10);
    if (Number.isNaN(parsedHour)) {
      return;
    }

    if (numericValue.length === 1) {
      if (parsedHour >= 2 && parsedHour <= 9) {
        setHourInputValue(parsedHour);
      }
      return;
    }

    if (parsedHour > 12) {
      const lastDigitHour: number = parseInt(numericValue.slice(-1), 10);
      if (!Number.isNaN(lastDigitHour) && lastDigitHour >= 1 && lastDigitHour <= 9) {
        setHourInputText(lastDigitHour.toString());
        setHourInputValue(lastDigitHour);
        return;
      }
    }

    const normalizedHour12: number = Math.min(12, Math.max(1, parsedHour));
    setHourInputText(normalizedHour12.toString());
    setHourInputValue(normalizedHour12);
  };

  const handleMinsChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
    const numericValue: string = event.target.value.replace(/\D/g, '').slice(0, 2);
    setMinsInputText(numericValue);

    if (numericValue === '') {
      return;
    }

    const parsedMinute: number = parseInt(numericValue, 10);
    if (Number.isNaN(parsedMinute)) {
      return;
    }

    if (numericValue.length === 1) {
      if (parsedMinute >= 0 && parsedMinute <= 5) {
        setMinsInputValue(parsedMinute);
      }
      return;
    }

    if (parsedMinute > 59) {
      const lastDigitMinute: number = parseInt(numericValue.slice(-1), 10);
      if (!Number.isNaN(lastDigitMinute) && lastDigitMinute >= 0 && lastDigitMinute <= 9) {
        setMinsInputText(lastDigitMinute.toString());
        setMinsInputValue(lastDigitMinute);
        return;
      }
    }

    const normalizedMinute: number = Math.min(59, Math.max(0, parsedMinute));
    setMinsInputText(normalizedMinute.toString().padStart(2, '0'));
    setMinsInputValue(normalizedMinute);
  };

  const selectInputTextOnNextTick = (input: HTMLInputElement): void => {
    window.setTimeout((): void => {
      input.select();
    }, 0);
  };

  const handleTimeInputPointerDown = (event: React.PointerEvent<HTMLInputElement>): void => {
    if (event.button !== 0) {
      return;
    }
    const input: HTMLInputElement = event.currentTarget;
    if (document.activeElement === input) {
      return;
    }
    event.preventDefault();
    input.focus({ preventScroll: true });
    selectInputTextOnNextTick(input);
  };

  const handleHourBlur = (): void => {
    commitHourInput(hourInputTextRef.current);
  };

  const handleMinsBlur = (): void => {
    commitMinuteInput(minsInputTextRef.current);
  };

  useEffect(() => {
    const hour24: number = convertTwelveHourClockTo24(hourInputValue, pmActive);
    const didHourChange: boolean = lastEmittedHour24Ref.current !== hour24;
    const didMinuteChange: boolean = lastEmittedMinuteRef.current !== minsInputValue;
    if (!didHourChange && !didMinuteChange) {
      return;
    }
    if (didHourChange) {
      lastEmittedHour24Ref.current = hour24;
      onFinalTimeChangeHourRef.current(hour24);
    }
    if (didMinuteChange) {
      lastEmittedMinuteRef.current = minsInputValue;
      onFinalTimeChangeMinuteRef.current(minsInputValue);
    }
    lastSyncedPrevHourRef.current = hour24;
    lastSyncedPrevMinRef.current = minsInputValue;
  }, [amActive, pmActive, hourInputValue, minsInputValue]);

  const handleAMClick = (): void => {
    setamActive(true);
    setpmActive(false);
  };

  const handlePMClick = (): void => {
    setamActive(false);
    setpmActive(true);
  };

  const rootClassName: string = [
    isMobile ? 'timepickerv4-mobile' : 'timepickerv4',
    isCompactDisplay ? WORKY_TIME_PICKER_V3_COMPACT_CLASS_NAME.ROOT : '',
  ]
    .filter((className: string): boolean => className.length > 0)
    .join(' ');
  const timeInputClassName: string = [
    isMobile ? 'time-input-mobile' : 'time-input',
    isCompactDisplay ? WORKY_TIME_PICKER_V3_COMPACT_CLASS_NAME.INPUT : '',
  ]
    .filter((className: string): boolean => className.length > 0)
    .join(' ');
  const amPmHolderClassName: string = [
    isMobile ? 'ampm-button-holder-mobile' : 'ampm-button-holder',
    isCompactDisplay ? WORKY_TIME_PICKER_V3_COMPACT_CLASS_NAME.AMPM_HOLDER : '',
  ]
    .filter((className: string): boolean => className.length > 0)
    .join(' ');

  return (
      <div
        style={
          isCompactDisplay
            ? { paddingLeft: '6px', paddingRight: '6px' }
            : { paddingLeft: '15px', paddingRight: '15px' }
        }
        className={rootClassName}
      >
        <input
          className={timeInputClassName}
          type="text"
          inputMode="numeric"
          pattern="[0-9]*"
          value={hourInputText}
          onChange={handleHourChange}
          onPointerDown={handleTimeInputPointerDown}
          onBlur={handleHourBlur}
          placeholder={initialHour12.toString()}
          aria-label="Hour"
        />
        :
        <input
          className={timeInputClassName}
          type="text"
          inputMode="numeric"
          pattern="[0-9]*"
          value={minsInputText}
          onChange={handleMinsChange}
          onPointerDown={handleTimeInputPointerDown}
          onBlur={handleMinsBlur}
          placeholder={resolvedPrevMin.toString().padStart(2, '0')}
          aria-label="Minute"
        />
        <div className={amPmHolderClassName}>
          {amActive ? <button type="button" onClick={handleAMClick} id='ampm-active' className='am-button'>AM</button> : <button type="button" onClick={handleAMClick} className='am-button'>AM</button>}
          {pmActive ? <button type="button" onClick={handlePMClick} id='ampm-active' className='pm-button'>PM</button> : <button type="button" onClick={handlePMClick} className='pm-button'>PM</button>}
        </div>
      </div>
  );
};



export type { WorkyTimePickerV3DisplayConfig, WorkyTimePickerV3Props };
export {WorkyTimePicker, WorkyTimePickerFuture, WorkyTimePickerV2, WorkyTimePickerV3}